module.exports = __webpack_public_path__ + "img/bee_smoker.1d57ff6f.png";